<div class="mt-[50px] pb-[16px] pl-[16px] flex items-center justify-between text-[14px] text-[#637381]">
  <div class="flex items-center">
    {{perPageText}} per page:
    <div class="relative">
      <button (click)="showPerPageDropdown = !showPerPageDropdown" class="ml-[12px] mr-[24px] px-[12px] py-[8px] border border-[#63738180] rounded-[8px] bg-[#FFF] text-[#333333] hover:border-[#718293] hover:bg-[#D6DBE0]">
        {{currentPagination.limit}}
        <fa-icon [icon]="faChevronDown" class="ml-[8px] text-[#637381]" />
      </button>
      @if (showPerPageDropdown) {
        <div class="perPageDropdown">
          <button (click)="changePaginationLimit(15)" class="w-full transition hover:text-rutgers-red hover:bg-[#FAE6EB] py-[6px]">
            15
          </button>
          <button (click)="changePaginationLimit(50)" class="w-full transition hover:text-rutgers-red hover:bg-[#FAE6EB] py-[6px]">
            50
          </button>
          <button (click)="changePaginationLimit(100)" class="w-full transition hover:text-rutgers-red hover:bg-[#FAE6EB] py-[6px]">
            100
          </button>
        </div>
      }
    </div>
    <p>Showing <span class="text-[#333333]">{{currentPagination.size}}</span> of {{currentPagination.totalcount}} results</p>
  </div>
  <!-- TODO finish pagination when endpoint is done -->
  <div class="flex items-center">
    <button [disabled]="currentPagination.page <= 0" (click)="changePage(currentPagination.page - 1)" class="pageButton">
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
        <path d="M4.06 8L5 7.06L1.94667 4L5 0.94L4.06 8.21774e-08L0.0599996 4L4.06 8Z" fill="black"/>
      </svg>
    </button>
    @if (currentPagination.page >= 1) {
      <button (click)="changePage(currentPagination.page - 1)" class="pageButton">
        {{currentPagination.page}}
      </button>
    }
    <button class="pageButtonSelected">
      {{currentPagination.page + 1}}
    </button>
    @if (currentPagination.page + 2 < Math.ceil(currentPagination.totalcount / currentPagination.limit)) {
      <button (click)="changePage(currentPagination.page + 1)" class="pageButton">
        {{currentPagination.page + 2}}
      </button>
    }
    @if (Math.ceil(currentPagination.totalcount / currentPagination.limit) > 1 && currentPagination.page + 1 < Math.ceil(currentPagination.totalcount / currentPagination.limit)) {
      <button (click)="changePage(Math.ceil(currentPagination.totalcount / currentPagination.limit) - 1)" class="pageButton">
        {{Math.ceil(currentPagination.totalcount / currentPagination.limit)}}
      </button>
    }
    <button [disabled]="Math.ceil(currentPagination.totalcount / currentPagination.limit) <= currentPagination.page + 1" (click)="changePage(currentPagination.page + 1)" class="pageButton">
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
        <path d="M0.94 0L0 0.94L3.05333 4L0 7.06L0.94 8L4.94 4L0.94 0Z" fill="black"/>
      </svg>
    </button>
  </div>
</div>
